import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import PageHeading from "../components/pageheading";
import "../styles/global.scss";

export default function Installations({ data }) {
  return (
    <Layout>
      <div className="installations">
        <PageHeading heading="Retail Installations" />

        <div className="block">
          <div className="text-l">
            <h4>Retail installations, visual merchandise, ePOS and more</h4>
            <p>
              Our experienced and capable team is able to fit out stores with
              installations of ePOS (Electronic Point Of Sale) equipment, visual
              merchandising and signage, COVID-19 compliant perspex screens and
              other retail installations.
              <br />
              Trusted by the big names and individuals alike, we’re pleased to
              tell you that no job is too big or too small.
              <br /> <br/>
              Should you need our services, we’re only a quick chat away.
            </p>
          </div>
          <div className="spacer"></div>
          <div className="img-r">
            <Img
              fluid={data.smilingWorkmen.childImageSharp.fluid}
              alt="two smiling workmen"
            />
          </div>
        </div>

        <div className="block">
          <div className="img-l">
            <Img
              fluid={data.exhibition.childImageSharp.fluid}
              alt="exhibition"
            />
          </div>
          <div className="spacer"></div>
          <div className="text-r">
            <h4>Exhibition setups, stalls and site closures</h4>
            <p>
              We can handle all your setup and takedown needs for exhibition
              setups, the stalls, the visual merchandising and branding, as well
              as takedowns and even site closures. This is the perfect service
              to request when setting up stalls and displays in centres like
              ExCel.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query {
    smilingWorkmen: file(relativePath: { eq: "smiling workmen.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    exhibition: file(relativePath: { eq: "exhibition.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;

